module.exports = __webpack_public_path__ + "img/fa-brands-400.2f122423.svg";